var _style, _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUbercart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#5F3813;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    className: "st0",
    width: 60,
    height: 60
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 167.8761,
    y1: -83.558,
    x2: 134.877,
    y2: -50.5589,
    gradientTransform: "matrix(1 0 0 -1 -126.3779 -46.1021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CE6502"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5CC01"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,47.6c-5.4,0-10.5-2.9-13.1-7.6L3.4,25.4C-0.8,18.2,1.7,8.9,9,4.7c2.3-1.3,4.9-2,7.6-2h16.9 c8.4,0,15.2,6.8,15.2,15.2c0,2.7-0.7,5.3-2,7.6l-8.4,14.6C35.5,44.8,30.4,47.7,25,47.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.4,3.4c8,0,14.5,6.5,14.5,14.5c0,2.5-0.7,5-1.9,7.3l-8.4,14.6c-4,6.9-12.9,9.3-19.8,5.3 c-2.2-1.3-4-3.1-5.3-5.3L4,25.1C0,18.2,2.4,9.3,9.3,5.3C11.5,4,14,3.4,16.6,3.4H33.4 M33.4,2H16.6C4.4,2-3.3,15.2,2.8,25.8 l8.4,14.6c4.4,7.6,14.1,10.2,21.7,5.8c2.4-1.4,4.4-3.4,5.8-5.8l8.4-14.6C53.3,15.2,45.6,2,33.4,2L33.4,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M18.2,31.5h-1.5c-1.1,0-1.9-0.9-1.9-1.9l0,0V13.5c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h3c0.2,0,0.4,0.2,0.4,0.4 c0,0,0,0,0,0v17.7C18.6,31.4,18.4,31.5,18.2,31.5C18.2,31.5,18.2,31.5,18.2,31.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.3,31.5h-1.9V13.1h3.8v16.6C35.2,30.7,34.3,31.5,33.3,31.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 29.6,
    className: "st3",
    width: 16.8,
    height: 1.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 14.2,
    className: "st3",
    width: 5.4,
    height: 2.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 6.3,
    className: "st3",
    width: 3,
    height: 4.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 6.3,
    className: "st3",
    width: 3,
    height: 4.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.6,32.9h2.7c0.7,0,1.2,0.5,1.2,1.2v2.7c0,0.7-0.5,1.2-1.2,1.2h-2.7c-0.7,0-1.2-0.5-1.2-1.2v-2.7 C15.4,33.4,15.9,32.9,16.6,32.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.7,32.9h2.7c0.7,0,1.2,0.5,1.2,1.2v2.7c0,0.7-0.5,1.2-1.2,1.2h-2.7c-0.7,0-1.2-0.5-1.2-1.2v-2.7 C29.5,33.4,30,32.9,30.7,32.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbercart);
export default __webpack_public_path__ + "static/media/ubercart.21abfcbae6386552b77c2932a64180e4.svg";
export { ForwardRef as ReactComponent };